// frontend/src/api/template.api.js
import apiClient from "./client.js";

export const getTemplates = (params = {}) =>
  apiClient.get("/templates", { params }).then((r) => r.data.data);

export const getTemplate = (id) =>
  apiClient.get(`/templates/${id}`).then((r) => r.data.data);

export const createTemplate = (formData) =>
  apiClient.post("/templates", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data.data);

export const updateTemplate = (id, data) =>
  apiClient.put(`/templates/${id}`, data).then((r) => r.data.data);

export const addTemplateVersion = (id, formData) =>
  apiClient.post(`/templates/${id}/versions`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data.data);

export const deleteTemplateVersion = (templateId, versionId) =>
  apiClient.delete(`/templates/${templateId}/versions/${versionId}`).then((r) => r.data.data);

export const getVersionDownloadUrl = (templateId, versionId) =>
  apiClient.get(`/templates/${templateId}/versions/${versionId}/download`).then((r) => r.data.data);
